// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"3e44b679","605":"8dbb3b3f","809":"62452d41","981":"9be3bd18"}[chunkId] + ".chunk.js";
};